// extracted by mini-css-extract-plugin
export default {"index_section":"FishIndex_index_section__7v4GL","search_input":"FishIndex_search_input__Z+ets","container_size":"FishIndex_container_size__8mqki"};